angular.module("app").component("signUpComponent", {
  templateUrl: "app/components/sign-up/sign-up.tmpl.html",
  controller: function (
    authService,
    $state,
    localStorageService,
    categoryValues,
    dataValidate,
    $http,
    appConfig
  ) {
    const self = this;
    self.email = "";
    self.password = "";
    self.isRemembered = false;
    self.error = "";
    self.serverError = "";
    self.response = false;
    self.widgetId = "";
    self.jobs = categoryValues("job function");
    // The first entry of each list is its own heading ("COMPANY SIZE",
    // "INDUSTRY", id null), not an answer; the dropdowns start on "Select".
    self.companySizes = categoryValues("company size").filter((c) => c.id !== null);
    self.industries = categoryValues("industry").filter((c) => c.id !== null);
    const products = { courses: {}, reports: {}, teaching_materials: {} };
    localStorageService.set("products", products);

    self.registry = {
      company: {
        value: "",
        required: true,
        name: "company name",
        type: "provide",
      },
      company_size: {
        value: null,
        required: false,
        name: "company size",
        type: "select",
      },
      industry: {
        value: null,
        required: false,
        name: "industry",
        type: "select",
      },
      first_name: {
        value: "",
        required: true,
        name: "first name",
        type: "provide",
      },
      last_name: {
        value: "",
        required: true,
        name: "last name",
        type: "provide",
      },
      email: { value: "", required: true, name: "email", type: "provide" },
      job_title: {
        value: "",
        required: true,
        name: "job title",
        type: "provide",
      },
      password: {
        value: "",
        required: true,
        name: "password",
        type: "provide",
      },
      password_confirmation: {
        value: "",
        required: true,
        name: "Confirm Password",
        type: "provide",
      },
    };

    self.model = {
      key: "6LfDJqwUAAAAACHIqavpN1wTmv8xwZImTU79S2I6",
    };

    self.register = () => {
      if (self.busy) return;
      self.reg_error = false;
      self.serverError = "";
      self.termsError = !self.isTandC;
      for (item in self.registry) {
        if (self.registry[item].required) {
          if (!self.registry[item].value) {
            self.registry[item].$error = true;
            self.registry[item].$error_msg =
              "Please Enter " + self.registry[item].name;
            self.reg_error = true;
          }
        }
      }

      if (
        self.registry.password.value !==
        self.registry.password_confirmation.value
      ) {
        self.registry.password_confirmation.$error = true;
        self.registry.password_confirmation.$error_msg =
          "Confirm Password must be same as Password";
        self.registry.password_confirmation.value = "";
        self.reg_error = true;
      } else {
        self.registry.password_confirmation.$error = false;
      }

      const data = {};

      for (item in this.registry) {
        if (item === "read" || item === "ticking" || item === "accept") {
          if (!self.registry[item].value) {
            self.registry[item].$error = true;
            self.reg_error = true;
          } else {
            self.registry[item].$error = false;
          }
        } else if (item === "rpassword") {
          self.registry[item].password_confirmation.$error = false;
        } else {
          if (self.registry[item].type === "select") {
            data[item] = self.registry[item].value ? self.registry[item].value.title : "";
          } else {
            data[item] = self.registry[item].value;
          }
        }
      }
      data.terms = self.isTandC;
      if (self.reg_error || self.termsError) {
      } else {
        self.busy = true;
        $http
          .post(appConfig.dashboardServiceUrl + "api/users.json", {
            user: data,
          })
          .then((res) => {
            $state.go("thank-you");
          })
          .catch((error) => {
            if (error.status === 422) {
              self.serverError = Object.keys(error.data.errors).map((key) => {
                const field = key.replace(/_/g, " ");
                return `${field.charAt(0).toUpperCase() + field.slice(1)} ${error.data.errors[key].join(", ")}`;
              });
            } else {
              self.serverError = ["Something went wrong. Please try again in a moment."];
            }
          })
          .finally(() => { self.busy = false; });
        self.response = false;
      }
    };

    self.setResponse = (res) => {
      self.response = res;
    };

    self.setWidgetId = (widgetId) => {
      self.widgetId = widgetId;
    };
  },
});
